import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import { Nav, NavDropdown, Navbar } from "react-bootstrap";
import { t } from "i18next";
import { AuthContext } from "@beeldit/user-and-access/auth/AuthContext";
import { User } from "@beeldit/user-and-access/users/models/User";
import { TenantAndCommerceContext } from "@main/contexts/TenantAndCommerceContext";
import { Key } from "@phosphor-icons/react";
import { getCommerceLogo } from "@main/commerces/utils/applyCommerceTheme";

interface MenuItem {
  label: string;
  to: string;
  children?: MenuItem[];
  icon?: any;
  roles?: string[];
}

interface SidebarProps {
  items: MenuItem[];
}

function createMenuItem(item: MenuItem, user: User, key?: string, isChild = false) {
  if (item.children) {
    if (item.roles && !item.roles.includes(user.role)) return null;
    return (
      <NavDropdown
        title={
          <>
            {item.icon}
            <span className={!isChild ? "d-none d-lg-inline" : ""}>
              {item.label}
            </span>
          </>
        }
        key={item.to}
        id={""}
      >
        {item.children.map((item) => {
          return createMenuItem(item, user, key, true);
        })}
      </NavDropdown>
    );
  }

  if (item.roles && !item.roles.includes(user.role)) return null;
  return (
    <Nav.Item key={item.to}>
      <NavLink to={item.to} className="nav-link hover-translate text-black-50">
        {item.icon}{" "}
        <span className={!isChild ? "d-none d-lg-inline" : ""}>
          {item.label}
        </span>
      </NavLink>
    </Nav.Item>
  );
}

function Sidebar(props: SidebarProps) {
  const { user } = useContext(AuthContext);

  const { items } = props;

  const { setCommerceId, tenant, commerce } = useContext(TenantAndCommerceContext);

  const tenantLogoUrl = () => {
    if (!tenant) return;
    // Hay que mirar en la propiedad media de tenant que es un array y mirar si hay algun elemento
    // Si lo hay, devolver la url de la imagen
    if (tenant.media && tenant.media.length > 0) {
      return tenant.media[0].original_url;
    }    
  }

  return (
    <Nav className="flex-column sidebar p-3">
      {
          <Navbar.Brand key="brand" href="#home" style={{ margin: '0.5rem 0' }}>
            <img src={getCommerceLogo()} alt="Logo" style={{ width: '220px', height: 'auto', display: 'block', marginLeft: 'auto', marginRight: 'auto' }} className="d-none d-lg-inline"/>
          </Navbar.Brand>
      }      
      {items.map((item: MenuItem, key: any) => {
        if (!user) return null;
        return createMenuItem(item, user, key);
      })}
       <Nav.Item className="border-top bottom">
        <NavLink to="/login" className="nav-link hover-translate text-black-50">
          <Key size={24} />
          <span className="d-none d-lg-inline">{t("logout")}</span>
        </NavLink>
      </Nav.Item>
    </Nav>
  );
}

export default Sidebar;
